// ===========================================================================
// テンプレート本文の保存の照合が外れた（開いたあとに他の人が保存していた）
// ===========================================================================
// template.js の updateTemplate / updateLayout / updateBlock に base_source_hash を
// 渡したとき、サーバ（cms の api/saver/template/source_hash.go）が返す U000132 を表す。
// 判定は save-conflict.js の isSaveConflictBody（フォーム項目と同じコード）。
//
// ⚠ 依存の無いモジュールにしておく（受ける側が axios まで読み込まずに済むように）。

export class TemplateSourceConflictError extends Error {
    constructor() {
        super('他の人がこのテンプレートを保存しています');
        this.name = 'TemplateSourceConflictError';
        this.conflict = true;
    }
}
